import {gql} from '@apollo/client';
import {pick} from '@benchling/js-utils';

import {Sequence} from 'components/Sequence';
import {SEQUENCE_TYPE_NATIVE_ENUM_TO_GQL_MAP} from 'constants/SequenceConstants';
import getNestedIdentifier from 'graphql-client/backbone-graphql-sync/getNestedIdentifier';
import {SyncedModelConfig, SyncedModelName} from 'graphql-client/backbone-graphql-sync/SyncedModels';
import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {ComponentSequenceGraphQL} from './__generated/ComponentSequenceGraphQL';

const COMPONENT_SEQUENCE_FRAGMENT = gql`
  fragment ComponentSequenceGraphQL on ComponentSequenceNode {
    bases @client
    id @client
    name @client
    nucleotideType @client
    sequencePrimers @client {
      id @client
    }
    modifiedNucleotides @client {
      position @client
      sugarMonomerId @client
      phosphateMonomerId @client
      baseMonomerId @client
    }
    startIndex @client
    type @client
  }
`;

export const ComponentSequenceFragment: FragmentWrapper<ComponentSequenceGraphQL> = {
  fragment: COMPONENT_SEQUENCE_FRAGMENT,
  fragmentName: 'ComponentSequenceGraphQL',
};

export const ComponentSequenceApolloConfig: SyncedModelConfig<SyncedModelName.COMPONENT_SEQUENCE> = {
  __typename: 'ComponentSequenceNode',

  fragmentWrapper: ComponentSequenceFragment,

  getGraphQLAttrs(sequence: Sequence): ComponentSequenceGraphQL {
    return {
      bases: sequence.bases(),
      modifiedNucleotides: sequence
        .get('_sequence')
        .get('modifiedNucleotides')
        .map((n) => ({
          __typename: 'ModifiedNucleotideNode',
          ...pick(n, 'position', 'sugarMonomerId', 'phosphateMonomerId', 'baseMonomerId'),
        })),
      name: sequence.name(),
      nucleotideType: sequence.nucleotideType(),
      sequencePrimers: sequence
        .sequencePrimers()
        .map((sequencePrimer) =>
          getNestedIdentifier(SyncedModelName.COMPONENT_SEQUENCE_PRIMER, sequencePrimer)
        ),
      startIndex: sequence.startIndex(),
      type: SEQUENCE_TYPE_NATIVE_ENUM_TO_GQL_MAP[sequence.type()],
      __typename: this.__typename,
      id: this.getId(sequence),
    };
  },

  getId(sequence: Sequence): string {
    return sequence.get('id');
  },
};
